import React from 'react';
import {
  View,
  Image,
} from 'react-native';
import * as FFObject from 'model/FFObject';
import * as API from 'generated/api';
import Chat from 'components/Chat';
import ChatHeader from 'components/ChatHeader';
import ViewportResponder from 'components/ViewportResponder';
import NavBar from 'components/NavBar';
import FixedView from 'components/FixedView';
import useClassname from 'utility/useClassname';
import { vec2 } from 'utility/gl-matrix';
import styles from './ViewChatPage.module.css';
import logo from 'images/Muze-logo.svg';

interface Props {
  chat: API.FFPublicChat;
  objects: Record<string, FFObject.FFObject>;
  fetchObjects: (minContentY: number, maxContentY: number) => void;
  chatKey: string;
}

export const ViewChatPage = ({
  chat,
  objects,
  fetchObjects,
  chatKey,
}: Props) => {
  useClassname(styles.body, document.body);

  return (
    <View
      style={{
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <ChatHeader chat={chat} />
      <ViewportResponder>
        {(viewportDimensions) => (
          <>
            <NavBar
              chat={chat}
              users={[]}
              chatKey={chatKey}
              style={{
                maxWidth: 600,
                width: '100%',
              }}
            />
            <Chat
              maxWidth={600}
              contentWidth={chat.width}
              contentInset={{ top: 0, bottom: 20 }}
              viewportSize={viewportDimensions}
              chat={chat}
              objects={objects}
              onViewportChanged={fetchObjects}
            />
            <FixedView
              style={
                vec2.x(viewportDimensions) > 800
                  ? {
                    left: 20,
                    top: 20,
                    height: 32,
                    width: 140,
              }
              : {
                /*
                right: 20,
                bottom: 20,
                height: 32,
                width: 140,
                */
                display: 'none',
              }
              }
            >
              <a href="https://muze.chat"> {/* DOM-only */}
                <Image source={{uri: logo, height: 32, width: 140}} />
              </a>
            </FixedView>
          </>
        )}
      </ViewportResponder>
    </View>
  );
}
